// (from: https://github.com/foxbenjaminfox/vue-async-computed/issues/25#issuecomment-459369072)

import { createDecorator, VueDecorator } from 'vue-class-component';
import { AsyncComputedGetter, IAsyncComputedValue } from 'vue-async-computed';

export function AsyncComputed<T>(
    computedOptions: AsyncComputedGetter<T> | IAsyncComputedValue<T>,
): VueDecorator {
    return createDecorator((options, key) => {
        options.asyncComputed = options.asyncComputed || {};
        options.asyncComputed![key] = computedOptions;
        delete options.methods![key];
    });
}
